<template>
  <v-container text-center>
    <v-container>
      <v-col xs12>
        <h1 :class="getConfigItem('H1_WELCOME_TEXT_CLASS')">
          {{ this.$store.state.nexaConfig.WELCOME_TEXT_2 }}
        </h1>
      </v-col>
      <v-col xs12>
        <h1 :class="this.getConfigItem('TICKET_TEXT_NUMBER_STYLE')">
          {{ this.getConfigItem("TICKET_TEXT") }} {{ ticketNumber }}
        </h1>
      </v-col>
      <v-col xs12>
        <h3 :class="this.getConfigItem('SERVICE_TEXT_NUMBER_STYLE')">
          {{ this.getConfigItem("CALL_TEXT") }}
        </h3>
      </v-col>
      <v-col xs12>
        <h2 v-if="unitName != null">{{ unitName }}</h2>
        <h2>{{ location }}</h2>
      </v-col>
      <v-col xs12>
        <v-btn
          color="info"
          :style="[
            { color: this.getConfigItem('INFO_COLOUR_TEXT') },
            { 'background-color': this.getConfigItem('BTN_BACKGROUND_COLOUR') },
          ]"
          @click="$root.backToHome()"
        >
          {{ this.getConfigItem("BTN_MAINMENU_TEXT") }}
        </v-btn>
      </v-col>
    </v-container>
  </v-container>
</template>

<script>
import axios from "axios";
import cookieMixin from "@/mixins/cookieMixin";
import { helper } from "@/helper";
import { mapGetters } from "vuex";

export default {
  mixins: [cookieMixin],
  data: function () {
    return {
      caseCookie: null,
      ticketNumber: null,
      unitName: null,
      location: null,
      intervalId: null,
    };
  },
  computed: {
    ...mapGetters([
      "isConfigLoaded",
      // "isShowLoadingMessage",
      // "getConfigItemNestedObjectValue",
      "getConfigItem",
    ]),
  },
  mounted: function () {
    this.caseCookie = helper.getCaseCookie();
    if (!this.caseCookie) {
      this.$router.push("/");
      return;
    }

    this.checkQueueCallInfo();

    this.intervalId = setInterval(() => {
      this.checkQueueCallInfo();
    }, this.getConfigItem("POLLING_TIME_MS"));
  },
  methods: {
    checkQueueCallInfo() {
      let self = this;
      axios
        .get("/Cases/" + this.caseCookie.CaseId)
        .then((response) => {
          this.ticketNumber = response.data.Ticket;

          if (response.data.LocationName) {
            this.location = response.data.LocationName;
            let selectedUnit = "";
            if (localStorage.selectedUnit) {
              JSON.parse(localStorage.selectedUnit);
            }
            this.unitName =
              selectedUnit.DisplayCurrentOrParent &&
              selectedUnit.DisplayCurrentOrParent == "PARENT"
                ? selectedUnit.ParentUnitName
                : selectedUnit.Name;
          } else {
            this.location = response.data.UnitName;
          }

          // if (process.env.VUE_APP_ISDEBUGGING) {
          //   console.log(
          //     "%c checkQueueCallInfo",
          //     "color:lightgreen",
          //     response.data.CaseStatus
          //   );
          // }

          if (
            response.data.CaseStatus != 0 ||
            response.data.EntityStatus === 15
          ) {
            helper.deleteCaseCookie();
            clearInterval(self.intervalId);
            self.$router.push("/");
          }

          if (
            response.data.EntityStatus === 3 ||
            response.data.EntityStatus === 11
          ) {
            clearInterval(self.intervalId);
            self.$router.push("EnqueueInfo");
          }
        })
        .catch(function (err) {
          console.log("%c err:", "color:red", err);

          clearInterval(self.intervalId);
        });
    },
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
};
</script>
